import styled, { keyframes } from "styled-components";
import { SpinLoaderProps } from "./SpinLoader.types";

export const SpinnerDelay = keyframes`
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
`;

export const PropelSpinLoader = styled.div<SpinLoaderProps>`
  display: inline-block;
  position: relative;
  width: ${(props: SpinLoaderProps) => (props.type ? props.type : "2")}rem;
  height: ${(props: SpinLoaderProps) => (props.type ? props.type : "2")}rem;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.3rem;
    border: 0.3rem solid
      ${(props: SpinLoaderProps) => (props.color ? props.color : "#000")};
    border-radius: 50%;
    animation: ${SpinnerDelay} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props: SpinLoaderProps) =>
        props.color ? props.color : "#000"}
      transparent transparent transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;
